import { api } from "services/api"

export const getUserPersonalInfo = async () => {
  const response = await api.get("/user")

  return response.data
}
